/**
 * Simple XOR + Base64 obfuscation to prevent sequential ID guessing
 * Note: This is for obfuscation, not high-level security.
 */

const SECRET_KEY = "SuvoriyCryptoKey";

export const encodeCertId = (id) => {
    if (!id) return "";
    // Ensure we only encode the numeric part if it's a string like "AL-123"
    const str = String(id).replace(/^AL-?/, "");
    let result = "";
    for (let i = 0; i < str.length; i++) {
        result += String.fromCharCode(str.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length));
    }
    // Convert to Base64 and make URL safe
    return btoa(result)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
};

export const decodeCertId = (hash) => {
    if (!hash) return "";
    try {
        // Restore Base64
        let base64 = hash.replace(/-/g, '+').replace(/_/g, '/');
        while (base64.length % 4) base64 += '=';

        const decoded = atob(base64);
        let result = "";
        for (let i = 0; i < decoded.length; i++) {
            result += String.fromCharCode(decoded.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length));
        }
        return result;
    } catch (e) {
        console.error("Decoding error:", e);
        return "";
    }
};
